export default __webpack_public_path__ + "static/media/InfoMark.f2cccdcb.svg";